import axios, { CancelTokenSource } from 'axios';

export interface ItemSuggestion {
  hkhsCode: string;
  description: string;
}

let cancelToken: CancelTokenSource;

const getSuggestedItems = async (description: string, size = 25): Promise<ItemSuggestion[]> => {
  if (cancelToken !== undefined) {
    // cancel previous quotation request if any
    cancelToken.cancel();
  }

  cancelToken = axios.CancelToken.source();

  const { data } = await axios.get('/api/items/autocomplete', {
    params: { description, size },
    cancelToken: cancelToken.token,
  });
  return data.data.matches || [];
};

export default getSuggestedItems;
